import React from 'react';
import { cn } from 'lib/utils';

type RichTextBaseProps = {
  content?: string;
  children?: React.ReactNode;
  className?: string;
  theme?: 'primary' | 'neutral' | 'neutral-dark';
  variant?: 'basic' | 'condensed';
};

export type RichTextProps<C extends React.ElementType> = RichTextBaseProps & {
  as?: C;
} & Omit<React.ComponentPropsWithoutRef<C>, keyof RichTextBaseProps | 'as'>;

const RichText = <C extends React.ElementType = 'div'>({
  as,
  content,
  children,
  className: classNameProp,
  theme = 'primary',
  variant = 'basic',
  ...rest
}: RichTextProps<C>) => {
  const Component = as || 'div';

  const className = cn(
    'rich-text',
    {
      'rich-text--primary': theme === 'primary',
      'rich-text--neutral': theme === 'neutral',
      'rich-text--neutral-dark': theme === 'neutral-dark',
      'rich-text--basic': variant === 'basic',
      'rich-text--condensed': variant === 'condensed',
    },
    classNameProp
  );

  if (content) {
    return (
      <Component
        dangerouslySetInnerHTML={{ __html: content }}
        {...{ className }}
        {...rest}
      />
    );
  }

  return (
    <Component {...{ className }} {...rest}>
      {children}
    </Component>
  );
};

export default RichText;
